const CREATIVE_EDITOR_TABS = {
    MEDIA_LIBRARY: 'mediaLibrary',
    RECOMMENDED_MEDIA: 'recommendedMedia',
    AI_GENERATED: 'aiGenerated',
};

export { CREATIVE_EDITOR_TABS };
export { default as FORM_MODE_CONFIG } from './formModeConfig';
export * from './creativeInitialValues';
